import React from 'react';
import styled from 'styled-components';
import { Text, Title } from '../../../../components';
import { COLORS, device } from '../../../../constants';
import { SHADOW } from '../../../../constants/animations';
import { MotionGridBlock } from '../../../../components/Motion';
type Props = {
  icon: React.FC;
  title: string;
  subtitle: string;
};

export const ActivityCard = ({ icon: Icon, title, subtitle }: Props) => {
  return (
    <IntroCardContent>
      <Icon />
      <Title
        title={title}
        size={24}
        weight={600}
        lineHeight={32.4}
        minHeight={23}
      />
      <Text text={subtitle} size={16} lineHeight={24} />
    </IntroCardContent>
  );
};

const IntroCardContent = styled(MotionGridBlock)`
  display: flex;
  flex-direction: column;
  flex-basis: 413px;
  flex-grow: 1;
  gap: 40px;
  background: ${COLORS.WHITE};
  padding: 40px;
  box-sizing: border-box;
  svg {
    width: 40px;
    height: 40px;
  }
  span {
    min-height: 64px;
  }
  &:hover {
    background: ${COLORS.GRAY_BG_COLOR};
    box-shadow: ${SHADOW.HOVER.SERVICE_CARD};
  }
  @media screen and ${device.xl} {
    max-width: calc(50% - 40px);
    span {
      min-height: 0;
    }
  }
  @media screen and ${device.lg} {
    span {
      min-height: 64px;
    }
  }
  @media screen and ${device.md} {
    padding: 20px;
    gap: 20px;
    max-width: none;
    span {
      min-height: 0;
    }
  }
  @media screen and ${device.sm} {
    svg {
      width: 25px;
      height: 25px;
    }
    padding: 10px;
    gap: 10px;
    > span {
      font-size: 18px;
    }
    > h4 {
      font-size: 15px;
      line-height: 20px;
    }
    > svg {
      width: 30px;
      height: 30px;
    }
  }
`;
